
const onRowUpdate = async () => {
 console.log('SPOSched onRowUpdate')
}

export default onRowUpdate
